import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import TableOfContentsRow from "./Row";
export default function TableOfContentsSection({ section, major, showSubSection = false, style = {} }) {
    const { sections } = section;
    return /*#__PURE__*/ _jsxs("div", {
        style: style,
        children: [
            /*#__PURE__*/ _jsx(TableOfContentsRow, {
                section: section,
                rowIndex: major
            }),
            showSubSection && sections && sections.map((subSection, minor)=>/*#__PURE__*/ _jsx(React.Fragment, {
                    children: /*#__PURE__*/ _jsx(TableOfContentsSection, {
                        section: subSection,
                        major: `${major}.${minor + 1}`,
                        showSubSection: showSubSection,
                        style: styles.indent
                    })
                }, `${major}.${minor}`))
        ]
    });
}
const styles = {
    indent: {
        paddingLeft: "1em"
    }
};
